import React from "react";
import { CustomerInfoContainer } from "../styled/pickup";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useRegex } from "../../../../../hooks/useRegex";

const CustomerInfo = ({ selected }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { TelFormat } = useRegex();
  const isCancel = () => (selected?.status || "").includes("CANCEL");

  const paymentType = {
    APP: "앱 (결제완료)",
    CARD: "카드",
    CASH: "현금",
  };

  return (
    <CustomerInfoContainer className={isCancel() ? "cancel" : ""}>
      {isMobile && <span>결제정보: {paymentType[selected?.paymentType] || "-"}</span>}
      {isMobile && <span>고객연락처: {TelFormat(selected?.mberTel)}</span>}
      {isCancel() ? (
        <span>취소사유: {selected?.cancelReason}</span>
      ) : (
        <span>주문시간: {moment(selected?.createdAt).format("a h시m분")}</span>
      )}
    </CustomerInfoContainer>
  );
};

export default CustomerInfo;
